import { createSelector } from 'reselect'
// import { List } from 'immutable'

const compensateRequestSelector = state => state.get('compensateRequest')

export const getIsFetching = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestGet.isFetching
    || compensateRequest.compensateRequestApprove.isFetching
    || compensateRequest.compensateRequestPreview.isFetching
    || compensateRequest.compensateRequestCreate.isFetching
    || compensateRequest.compensateRequestCancel.isFetching
  }
)
export const getIsFetchingApprove = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestApprove.isFetching
  }
)
export const getMyCompensateRequests = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestGet.compensateWithMeta
  }
)
export const getCompensateRequestsByGroup = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestGet.compensateWithMeta
  }
)
export const getMetaCompensateRequest = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestPreview
  }
)
export const createCompensateRequestData = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestCreate
  }
)
export const approveCompensateRequestData = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestApprove.updatedCompensate
  }
)
export const cancelCompensateRequestData = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return compensateRequest.compensateRequestCancel
  }
)
export const redirectCompensateRequest = createSelector(
  compensateRequestSelector,
  compensateRequestImmutable => {
    const compensateRequest = compensateRequestImmutable.toJS()
    return ({
      redirect: (compensateRequest.compensateRequestGet.redirect
      || compensateRequest.compensateRequestApprove.redirect
      || compensateRequest.compensateRequestPreview.redirect
      || compensateRequest.compensateRequestCreate.redirect
      || compensateRequest.compensateRequestCancel.redirect),
      isAuthenticated: (compensateRequest.compensateRequestGet.isAuthenticated
      || compensateRequest.compensateRequestApprove.isAuthenticated
      || compensateRequest.compensateRequestPreview.isAuthenticated
      || compensateRequest.compensateRequestCreate.isAuthenticated
      || compensateRequest.compensateRequestCancel.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/compensate-request/compensate-request-selector.js